<p-dialog
  *ngIf="displayEntitySelectionDialog"
  [header]="displayName + ' auswählen'"
  [modal]="true"
  [(visible)]="displayEntitySelectionDialog"
  [style]="{ width: '80%' }"
  appendTo="body"
>
  <jml-lib-dynamic-table
    *ngIf="entitySelectionTableData"
    [tableData]="entitySelectionTableData"
    (entitySelection)="entitySelected($event, entityForm)"
    [isRootEntity]="false"
  ></jml-lib-dynamic-table>
</p-dialog>

<p-dialog
  *ngIf="showCodeEditor"
  [header]="
    configuration.singleDisplayName + ' ' + (entity ? entity._repr_ : '(Neu)') + ' - ' + codeSelCntxt.field.header
  "
  [modal]="true"
  [(visible)]="showCodeEditor"
  [style]="{ width: '80%', height: '80%' }"
  appendTo="body"
>
  <jml-lib-code-editor
    [syntax]="syntax"
    [code]="code"
    saveButtonLabel="Übernehmen"
    (editedCode)="onEdited($event, entityForm)"
  ></jml-lib-code-editor>
</p-dialog>

<div *ngIf="description" class="mb-2 flex align-items-center">
  <div class="pr-2"><i class="pi pi-info-circle"></i></div>
  <p class="text-color-secondary" [innerText]="description.replace('\\n', '\n')"></p>
</div>

<form (ngSubmit)="onSubmit(entityForm)" #entityForm="ngForm">
  <fieldset [disabled]="!formEnabled" class="m-0 p-0 border-none">
    <div class="form-group">
      <div id="formFieldDiv" #formFieldDiv [style]="scrollPanelStyle" (window:resize)="onWindowResize()">
        <ng-container [ngTemplateOutlet]="formFields"></ng-container>
      </div>

      <div class="col">
        <p-button
          type="submit"
          [disabled]="!entityForm.form.valid"
          icon="pi pi-check"
          iconPos="left"
          [label]="buttonText"
        >
        </p-button>
      </div>
    </div>

    <ng-template #formFields>
      <div *ngFor="let field of fields">
        <div
          [ngSwitch]="true"
          *ngIf="(field.mandatory || field.editable) && (field.type !== 'State' || !!entity)"
          class="col mb-2 flex"
        >
          <!-- String -->
          <span *ngSwitchCase="field.type === 'String'" class="p-float-label formFields">
            <input
              [required]="field.mandatory"
              pattern="^(\s+\S+\s*)*(?!\s).*$"
              [name]="field.field"
              [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
              id="{{ field.header + '-' + field.field | lowercase }}"
              type="text"
              class="w-full"
              pInputText
            />
            <label for="{{ field.header + '-' + field.field }}">{{ field.header }}</label>
          </span>
          <!-- Multiline -->
          <ng-template [ngSwitchCase]="field.type === 'Multiline'">
            <span class="p-float-label formFields">
              <input
                [required]="field.mandatory"
                [name]="field.field"
                [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
                class="hidden"
              />
              <input
                #input
                (keyup.Space)="openMultilineEditor(field, input, entityForm)"
                id="float-input"
                readonly
                type="text"
                class="w-full cursor-pointer"
                [ngModel]="filterTags(entity ? entity[field.field] : defaultCache[field.field])"
                [ngModelOptions]="{ standalone: true }"
                (click)="openMultilineEditor(field, input, entityForm)"
                pInputText
              />
              <label for="float-input">{{ field.header }}</label>
            </span>
            <button
              pButton
              type="button"
              (click)="openMultilineEditor(field, input, entityForm)"
              icon="pi pi-pencil"
            ></button>
          </ng-template>
          <!-- Integer -->
          <span *ngSwitchCase="field.type === 'int'" class="p-float-label formFields">
            <input
              [required]="field.mandatory"
              autocomplete="off"
              [name]="field.field"
              [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
              pattern="^-?\d{1,3}((\.)?\d{3})*$"
              id="{{ field.header + '-' + field.field | lowercase }}"
              type="text"
              pInputText
              style="width: 14rem"
            />
            <label for="float-input">{{ field.header }}</label>
          </span>
          <!-- Float -->
          <span *ngSwitchCase="field.type === 'float'" class="p-float-label formFields">
            <input
              [required]="field.mandatory"
              autocomplete="off"
              [name]="field.field"
              type="text"
              pattern="{{ getFloatPattern(field.decimals) }}"
              id="{{ field.header + '-' + field.field | lowercase }}"
              pInputText
              [ngModel]="
                entity && entity[field.field] !== undefined && entity[field.field] !== null
                  ? entity[field.field].toLocaleString('de', {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: !field.decimals ? 20 : field.decimals
                    })
                  : defaultCache[field.field] !== undefined
                    ? defaultCache[field.field].toLocaleString('de', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: !field.decimals ? 20 : field.decimals
                      })
                    : ''
              "
            />
            <label for="float-input">{{ field.header }}</label>
          </span>
          <!-- Currency -->
          <div *ngSwitchCase="field.type === 'Currency'" class="formFields">
            <jml-lib-currency-control
              [required]="field.mandatory"
              [name]="field.field"
              [placeholder]="field.header"
              [float]="true"
              id="{{ field.header + '-' + field.field | lowercase }}"
              [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
            ></jml-lib-currency-control>
          </div>
          <!-- Boolean -->
          <span *ngSwitchCase="field.type === 'boolean'" class="flex-grow-1 align-self-center">
            <p-checkbox
              [required]="field.mandatory"
              [name]="field.field"
              [binary]="true"
              [label]="field.header"
              [ngModel]="entity ? entity[field.field] : defaultCache[field.field] ? defaultCache[field.field] : false"
            ></p-checkbox>
          </span>

          <!-- Date -->
          <span *ngSwitchCase="field.type === 'Date'" class="p-float-label formFields">
            <p-calendar
              [required]="field.mandatory"
              [name]="field.field"
              [locale]="de"
              showIcon="true"
              dateFormat="dd.mm.yy"
              [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
              [inputStyle]="{ width: '170px' }"
              firstDayOfWeek="1"
              appendTo="body"
            ></p-calendar>
            <label for="float-input">{{ field.header }}</label>
          </span>

          <!-- DateTime -->
          <span *ngSwitchCase="field.type === 'DateTime'" class="p-float-label formFields">
            <p-calendar
              [required]="field.mandatory"
              [name]="field.field"
              [locale]="de"
              showIcon="true"
              showTime="true"
              dateFormat="dd.mm.yy"
              [hideOnDateTimeSelect]="false"
              [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
              [inputStyle]="{ width: '170px' }"
              firstDayOfWeek="1"
              appendTo="body"
            ></p-calendar>
            <label for="float-input">{{ field.header }}</label>
          </span>

          <!-- DatePeriod -->
          <span *ngSwitchCase="field.type === 'DatePeriod'" class="p-float-label formFields">
            <p-calendar
              [required]="field.mandatory"
              [name]="field.field"
              [locale]="de"
              showIcon="true"
              dateFormat="dd.mm.yy"
              selectionMode="range"
              (onClose)="onDatePeriodClose(field.field, entityForm)"
              [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
              [inputStyle]="{ width: '170px' }"
              firstDayOfWeek="1"
              appendTo="body"
            ></p-calendar>
            <label for="float-input">{{ field.header }}</label>
            {{ defaultCache[field.field] }}
          </span>

          <!-- CalendarWeek -->
          <span *ngSwitchCase="field.type === 'CalendarWeek'" class="p-float-label formFields">
            <input
              [required]="field.mandatory"
              autocomplete="off"
              [name]="field.field"
              [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
              pattern="^(?:[1-9]|[1-4][0-9]|50|51|52|53)$"
              id="float-input"
              type="text"
              pInputText
            />
            <label for="float-input">{{ field.header }}</label>
          </span>

          <!-- Catalogue Entry -->
          <ng-template [ngSwitchCase]="_isCatalogueEntry(field)">
            <span class="formFields">
              <p-dropdown
                [required]="field.mandatory"
                [placeholder]="field.header"
                [name]="field.field"
                [style]="{ width: '200px' }"
                appendTo="body"
                [options]="catalogueOptions.get(field.defaultCatalogue)"
                [panelStyle]="{ 'max-width': '400px' }"
                panelStyleClass="dropdownWidthFix"
                [ngModel]="entity ? entity[field.field]?.id : defaultCache[field.field]?.id"
                (onChange)="revalidate(entityForm, field.field)"
              ></p-dropdown>
            </span>
            <button
              *ngIf="!field.mandatory"
              pButton
              type="button"
              tabindex="-1"
              (click)="nullField(field, entityForm)"
              icon="pi pi-times"
            ></button>
          </ng-template>

          <!-- Reference -->
          <ng-template [ngSwitchCase]="_isEntityReference(field)">
            <span class="p-float-label formFields">
              <input
                #textModule
                readonly
                id="float-input"
                class="w-full cursor-pointer"
                pInputText
                autocomplete="off"
                (keyup.Space)="openEntitySelectionDialog(field, textModule)"
                [value]="
                  entity && entity[field.field]
                    ? entity[field.field]._repr_
                    : defaultCache[field.field]
                      ? defaultCache[field.field]._repr_
                      : ''
                "
                (click)="openEntitySelectionDialog(field, textModule)"
                [class.ng-invalid]="field.mandatory && !entityForm.value[field.field]"
              />
              <input
                [required]="field.mandatory"
                [name]="field.field"
                type="hidden"
                [ngModel]="
                  entity ? entity[field.field] : defaultCache[field.field] ? defaultCache[field.field] : undefined
                "
                (ngModelChange)="evaluateFieldsOnChange($event, field, entity, entityForm)"
              />
              <label for="float-input">{{ field.header }}</label>
            </span>
            <button
              pButton
              type="button"
              (click)="openEntitySelectionDialog(field, textModule)"
              icon="pi pi-pencil"
            ></button>
            <button
              *ngIf="!field.mandatory"
              pButton
              type="button"
              tabindex="-1"
              (click)="nullField(field, entityForm); textModule['value'] = null"
              icon="pi pi-times"
            ></button>
          </ng-template>

          <!-- Password -->
          <span *ngSwitchCase="field.type === 'Password'" class="p-float-label formFields">
            <input
              [required]="field.mandatory"
              [name]="field.field"
              autocomplete="new-password"
              class="w-full"
              [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
              type="password"
              pInputText
            />
            <label>{{ field.header }}</label>
          </span>

          <!-- Code JSON or Pyton -->
          <ng-template [ngSwitchCase]="field.type === 'json' || field.type === 'python'">
            <span class="p-float-label formFields">
              <input
                #textModule
                [required]="field.mandatory"
                readonly
                class="w-full"
                id="float-input"
                class="cursor-pointer"
                pInputText
                autocomplete="off"
                (keyup.Space)="openCodeEditor(field, textModule, entityForm)"
                [ngModel]="entity && entity[field.field] ? '<' + field.type + '>' : undefined"
                [ngModelOptions]="{ standalone: true }"
                (click)="openCodeEditor(field, textModule, entityForm)"
                style="width: 100%"
              />
              <input
                [required]="field.mandatory"
                [name]="field.field"
                [ngModel]="entity ? entity[field.field] : undefined"
                type="hidden"
              />
              <label for="float-input">{{ field.header }}</label>
            </span>
            <button
              pButton
              type="button"
              (click)="openCodeEditor(field, textModule, entityForm)"
              icon="pi pi-pencil"
            ></button>
          </ng-template>

          <!-- DTO Type -->
          <span *ngSwitchCase="field.type === 'dtoType'" class="formFields">
            <p-dropdown
              [required]="field.mandatory"
              [placeholder]="field.header"
              [name]="field.field"
              [style]="{ width: '200px' }"
              appendTo="body"
              [options]="dtoConfigs"
              [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
              [panelStyle]="{ 'max-width': '400px' }"
              panelStyleClass="dropdownWidthFix"
            ></p-dropdown>
          </span>

          <!-- SelectList -->
          <ng-template [ngSwitchCase]="field.type === 'SelectList' && field.listType === 'Reference'">
            <jml-lib-select-list
              *ngIf="!!(entity ? entity[field.field] : defaultCache[field.field]); else noSelectList"
              [name]="field.field"
              [referenceType]="field.referenceType"
              [listType]="field.listType"
              [data]="entity ? entity[field.field] : defaultCache[field.field]"
              ngModel
            ></jml-lib-select-list>
          </ng-template>
          <ng-template #noSelectList>
            <span>Es sind keine {{ field.header }} zur Auswahl vorhanden.</span>
          </ng-template>

          <!-- Icon -->
          <jml-lib-icon-control
            *ngSwitchCase="field.type === 'Icon'"
            class="formFields"
            [required]="field.mandatory"
            [name]="field.field"
            [field]="field"
            [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
          ></jml-lib-icon-control>

          <!-- Color -->
          <span
            *ngSwitchCase="field.type === 'Color'"
            class="formFields"
            style="width: 100%; display: flex; align-items: center; gap: 0.5rem"
          >
            <p-colorPicker
              [name]="'p' + field.field"
              (onChange)="exchangeValue($event, field.field, entityForm)"
              [ngModel]="entity && entity[field.field] ? entity[field.field] : '#636363'"
              appendTo="body"
            ></p-colorPicker>
            <span class="p-float-label">
              <input
                [required]="field.mandatory"
                #colorInput
                pattern="^#([a-fA-F0-9]{6})$"
                (keyup)="exchangeValue($event, 'p' + field.field, entityForm)"
                [name]="field.field"
                id="float-input"
                type="text"
                [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
                style="width: 100%"
                pInputText
              />
              <label for="float-input">{{ field.header }}</label>
            </span>
          </span>

          <!-- IconDefinition -->
          <span *ngSwitchCase="field.type === 'IconDefinition'" class="p-float-label formFields">
            <input
              [name]="field.field"
              [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
              type="text"
              class="w-full;"
              pInputText
              [iconPicker]="entity ? entity[field.field] : defaultCache[field.field]"
              [ipIconPack]="['fa']"
              (iconPickerSelect)="onIconPickerSelect($event, field, entityForm)"
            />
            <label for="float-input">{{ field.header }}</label>
          </span>

          <!-- Address -->
          <jml-lib-address-control
            *ngSwitchCase="field.type === 'Address'"
            [header]="field.header"
            [field]="field"
            class="formFields"
            [required]="field.mandatory"
            [name]="field.field"
            [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
          ></jml-lib-address-control>

          <!-- State Machine (only shown when updating entity) -->
          <jml-lib-fsm-control
            *ngSwitchCase="field.type === 'State'"
            class="w-full"
            [field]="field"
            [required]="field.mandatory"
            [name]="field.field"
            [entityType]="configType"
            [entityId]="entity['id']"
            [ngModel]="entity ? entity[field.field] : defaultCache[field.field]"
          ></jml-lib-fsm-control>

          <!-- Cron -->
          <ng-template [ngSwitchCase]="field.type === 'TriggerDefinition'">
            <span class="p-float-label formFields">
              <input
                #input
                [required]="field.mandatory"
                [name]="field.field"
                pInputText
                class="w-full cursor-pointer"
                (click)="openCronEditor(field, input, entityForm)"
                (keyup.Space)="openCronEditor(field, input, entityForm)"
                [ngModel]="displayCron(field.field)"
                id="float-input"
                readonly
                type="text"
              />
              <label for="float-input">{{ field.header }}</label>
            </span>
            <button
              pButton
              type="button"
              (click)="openCronEditor(field, input, entityForm)"
              icon="pi pi-pencil"
            ></button>
          </ng-template>

          <button
            *ngIf="
              !_isCatalogueEntry(field) &&
              field.type !== 'boolean' &&
              !_isEntityReference(field) &&
              field.type !== 'json' &&
              field.type !== 'python' &&
              field.type !== 'SelectList' &&
              (field.type !== 'Icon' || !field.mandatory) &&
              field.type !== 'Multiline' &&
              field.type !== 'State'
            "
            pButton
            type="button"
            tabindex="-1"
            (click)="nullField(field, entityForm)"
            icon="pi pi-times"
          ></button>
        </div>
      </div>
    </ng-template>
  </fieldset>
</form>
